import {connect} from 'react-redux';

import {
  InterfaceEventsEnum,
  trackInterfaceEvent,
} from '../../../../../../libs/shared/core/src/services/tracking/tracking';
import {
  createSelector,
  makeMapDispatchToProps,
  makeMapStateToProps,
  wrapInShallowSelector,
} from '../../../../../../srcCommon/helpers/reselectHelpers';
import {findParentTags} from '../../../../../helpers/models/tagHelpers';
import {TagModel} from '../../../../../models/api/tagModel';
import {AppState} from '../../../../../store/appState';
import {getHasPermission} from '../../../../../store/data/access/accessSelectors';
import {makeGetConversation} from '../../../../../store/data/conversations/conversationsSelectors';
import {
  addTagToConversationsAction,
  removeTagFromConversationsAction,
} from '../../../../../store/data/conversations/tagConversationsActions';
import {getTags} from '../../../../../store/data/tags/tagsSelectors';
import {
  getFlatActiveOrPendingTeammates,
  getUserId,
} from '../../../../../store/data/teammates/teammatesSelectors';
import {ActivityTagPill} from './activityTagPill';

/*
 * Props.
 */

interface ActivityTagPillContainerProps {
  tag: TagModel;
  conversationId: number;
}

/*
 * Selectors.
 */

function getTagId(_state: AppState, props: ActivityTagPillContainerProps) {
  return props.tag.id;
}

function getTag(_state: AppState, props: ActivityTagPillContainerProps) {
  return props.tag;
}

function getConversationId(_state: AppState, props: ActivityTagPillContainerProps) {
  return props.conversationId;
}

function makeGetIsTagAddedToConversation() {
  const getConversation = makeGetConversation(getConversationId);

  return createSelector([getTagId, getConversation], (tagId, conversation) =>
    conversation ? conversation.tagIds.includes(tagId) : false,
  );
}

function makeGetTagsPath() {
  return createSelector([getTags, getTag], (tags, tag) => [tag, ...findParentTags(tags, tag)]);
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ActivityTagPillContainerProps>()(() => ({
  userId: getUserId,
  tagsPath: wrapInShallowSelector(makeGetTagsPath()),
  teammates: getFlatActiveOrPendingTeammates,
  hasPermission: getHasPermission,
  isTagAddedToConversation: makeGetIsTagAddedToConversation(),
}));

const mapDispatchToProps = makeMapDispatchToProps<ActivityTagPillContainerProps>()((props) => ({
  onAddTag: () => {
    const {tag, conversationId} = props;
    trackInterfaceEvent(InterfaceEventsEnum.P3_ADD_TAG_USING_ACTIVITY, {
      conversation_id: conversationId,
      tag_id: tag.id,
    });

    return addTagToConversationsAction([conversationId], tag.id, [tag]);
  },
  onUntag: () => {
    const {tag, conversationId} = props;
    trackInterfaceEvent(InterfaceEventsEnum.P3_REMOVE_TAG_USING_ACTIVITY, {
      conversation_ids: [conversationId],
      tag_id: tag.id,
    });

    return removeTagFromConversationsAction([conversationId], tag.id);
  },
}));

export const ActivityTagPillContainer = connect(mapStateToProps, mapDispatchToProps)(ActivityTagPill);
